import * as React from 'react';
import styles from './index.less';
import {Switch} from "antd";
import type { SwitchProps } from 'antd';

interface FSwitchProps extends SwitchProps {

}

function FSwitch({...props}: FSwitchProps) {
  return (<Switch
    size="small"
    className={styles.styles}
    {...props}
  />);
}

export default FSwitch;
